
// 公共-获取OSS签名 接口
import request from '@/utils/request.js'

/**
* 目录
* @param params
* @returns {AxiosPromise}
*/
export function getPolicy(params) {
	return request({
		url: '/studyService/api/oss/object/getPolicy',
		method: 'post',
		data: params
	})
}

/**
* 根据目录获取policy
* @param params
* @returns {AxiosPromise}
*/
export function getPolicyByFolder(params) {
	return request({
		url: '/studyService/api/oss/object/getPolicyByFolder',
		method: 'post',
		data: params
	})
}
// 方法列表
// getPolicy，getPolicyByFolder